"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const reactstrap_1 = require("reactstrap");
const react_2 = require("@osmosys/react");
exports.HelpNavItem = () => {
    return (react_1.default.createElement(react_2.OsmosysTooltip, { label: "Help" },
        react_1.default.createElement(reactstrap_1.NavLink, { tag: react_router_dom_1.Link, to: "/help" },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faInfoCircle, style: { height: 18, width: 18 } }))));
};
//# sourceMappingURL=HelpNavItem.js.map